var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"timeout font26"},[_c('van-empty',{attrs:{"image":"network","description":"网络请求失败，请检查您的网络"}}),_c('div',{staticClass:"refresh",on:{"click":_vm.reloadBtn}},[_vm._v("重新加载")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }